<template>
    <b-row>
        <b-col cols="12" class="py-5">
            <h3>¿Conoces algún abonado?</h3>
            <h5>Introduce aquí su número de abonado para activar la promoción</h5>
            <template v-if="! promocion_confirmada">
                <ValidationObserver tag="form" ref="observer" @submit.prevent="buscar()">
                    <div class="input-group">
                        <input class="form-control w-auto" id="input-referidos" v-model="n_abonado" placeholder="Número de abonado"/>
                        <button class="button large-button" type="submit" :disabled="disabled">Verificar</button>
                    </div>
                </ValidationObserver>
            </template>
            <template v-else>
                <div class="input-group">
                    <input class="form-control w-auto" id="input-referidos" v-model="n_abonado" placeholder="Número de abonado" disabled/>
                    <button class="button large-button" style="background-color: #80bf78;"><i class="fa fa-check-circle"></i></button>
                </div>
            </template>            
            <b-modal 
                v-if="abonado" 
                id="abonado-modal" 
                title="Datos del abonado" 
                centered
                @ok="confirmarAbonado()"
                @cancel="cancelar()"
            >
                <b-row>
                    <b-col cols="12">
                        <ul>
                            <li>Nombre: {{ abonado.name }} {{ abonado.surnames }}</li>
                        </ul>
                    </b-col>
                    <b-col cols="12" class="text-center">
                        <h3>¿Es correcto este abonado?</h3>
                    </b-col>
                </b-row>
            </b-modal>
        </b-col>
    </b-row>
</template>

<script>
    export default {
        props: {
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                n_abonado: null,
                abonado: null,
                promocion_confirmada: false
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            }
        },
        methods: {
            async buscar() {
                const isValid = await this.$refs.observer.validate();
                if (isValid) {
                    this.$store.dispatch(this.config.getVuexAlias('front.abonados.buscar.referido'), {
                        filters: {
                            tid: this.configuracion.hash_teatro
                        },
                        n_abonado: this.n_abonado
                    }).then(res => {
                        this.abonado = res.data.data;
                        setTimeout(() => {
                            this.$bvModal.show('abonado-modal');
                        }, 200);   
                    }).catch(error => {
                        this.$toast.error('Abonado no encontrado');
                    }); 
                }
            },
            confirmarAbonado() {
                this.promocion_confirmada = true;
                this.$emit('confirmado', this.abonado.id);
            },
            cancelar() {
                this.abonado = null;
                this.n_abonado = null;
            }
        }
    }
</script>